import { render } from "./PreOrdini.vue?vue&type=template&id=53957b6e&scoped=true"
import script from "./PreOrdini.vue?vue&type=script&lang=js"
export * from "./PreOrdini.vue?vue&type=script&lang=js"

import "./PreOrdini.vue?vue&type=style&index=0&id=53957b6e&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53957b6e"]])

export default __exports__